const React = require('react');
const createReactClass = require("create-react-class");

/**
 * Basic panel to output the contents of a text area from Grafana
 */
const TextPanel = createReactClass({
  getInitialState: function() {
    return {
      item: this.props.item
    };
  },

  render: function() {
    const panelWidth = Math.floor(this.state.item.data.gridPos.w / 2);
    return (
      <div className={"metric-panel metric-text-panel col-sm-" + panelWidth}>
        {this.state.item.data.content}
      </div>
    );
  }
});

module.exports = TextPanel;
